import { storage, firestore } from './firebase';
import { ref, uploadBytes, getDownloadURL, uploadString } from 'firebase/storage';
import { doc, updateDoc } from 'firebase/firestore';

  export const uploadFileToDatabaseRef = (key, file, documentPath, cb) => {
    let fileRef = ref(storage, documentPath+key);
    return uploadBytes(fileRef, file).then((snapshot) => {
      getDownloadURL(snapshot.ref).then((downloadURL) => {
        const docRef = doc(firestore, documentPath);
        updateDoc(docRef, {[key]: downloadURL});
        // const memberDocRef = doc(firestore, `teams/${teamId}/members/${memberId}`);
        // updateDoc(memberDocRef, {'profilePic': downloadURL}).then(() => { cb(downloadURL) });
        cb(downloadURL);
      });
    });
  }

  export const uploadProfilePic = (teamId, memberId, file, cb) => {    
    let profileRef = ref(storage, `teams/${teamId}/members/${memberId}/profilepic`);
    uploadBytes(profileRef, file).then((snapshot) => {
      getDownloadURL(snapshot.ref).then((downloadURL) => {
        const memberDocRef = doc(firestore, `teams/${teamId}/members/${memberId}`);
        updateDoc(memberDocRef, {'profilePic': downloadURL}).then(() => {
          cb(downloadURL);
        });
      });
    });
  }

  export const uploadFile = (teamId, file, cb) => {
    let fileRef = ref(storage, "company/" + teamId + '/files');
    return uploadBytes(fileRef, file).then((snapshot) => {
      getDownloadURL(snapshot.ref).then((downloadURL) => {
        cb(downloadURL);
      });
    });
  }
  export const uploadFileToPath = (filePath, file, cb) => {
    let fileRef = ref(storage, filePath);
    return new Promise((resolve, reject) => {
      uploadBytes(fileRef, file).then((snapshot) => {
        getDownloadURL(snapshot.ref).then((downloadURL) => {
          resolve(downloadURL);
        }).catch(e => {
          console.log(e);
          reject(e);
        });
      }).catch(e => {
        console.log(e);
        reject(e);
      });
    });
  }

  export const uploadFileWithPath = (teamId, path, file, cb) => {
    let fileRef = ref(storage, "company/" + teamId + '/files/' + path);
    return uploadBytes(fileRef, file).then((snapshot) => {
      getDownloadURL(snapshot.ref).then((downloadURL) => {
        cb(downloadURL);
      });
    });
  }

  export const uploadSignature = (companyID, path, b64String) => {
    let fileRef = ref(storage, "public/" + companyID + '/signatures' + path);
    return uploadString(fileRef, b64String.replace('data:image/png;base64,',''), 'base64', {contentType:'image/png'}).then(async (snapshot) => {
      return await getDownloadURL(snapshot.ref);
    });
  }
